<template>
    <!-- 头部的上方 -->
    <div class="header1">
        <div class="top-head">
            <el-row class="contain">
                <el-col :span="7">
                    <div class="head-title">欢迎访问畅通圆！</div>
                </el-col>
                <el-col :span="17">
                    <div class="topIndex">
                        <el-menu
                            class="el-menu-black red-down red-title-nav"
                            id="topNav"
                            mode="horizontal"
                            background-color="#f64420"
                            @select="handleSelect"
                            text-color="#fcc2b6"
                            :router="true"
                            :default-active="onRoutes"
                        >
                            <!-- <el-menu-item
                                index="/ysRegister"
                                v-if="!isYS"
                                :class="displayNone?'displayNoneClass':''"
                            >{{ysWords}}</el-menu-item> -->
                            <el-menu-item index="/doctorInfo" v-if="userInfo.userType==1" >医师注册</el-menu-item>
                            <el-menu-item index="/wholesalerInfo" v-if="userInfo.isMerchant==0" >批发商注册</el-menu-item>
                            <el-menu-item index="/login" v-if="login">登录</el-menu-item>
                            <el-menu-item index="/register" v-if="login">注册</el-menu-item>

                            <el-submenu index="2" v-if="!login">
                                <template slot="title">
                                    <p class="HeadPortrait">
                                        <img :src="$store.state.imgUrl+userInfo.headImg" alt />
                                    </p>
                                    <span>{{userInfo.username?userInfo.username:'游客'}}</span>
                                </template>

                                <el-menu-item @click="signOut()">退出</el-menu-item>
                            </el-submenu>
                            <el-submenu index="4" v-if="!login">
                                <template slot="title">我的信息</template>
                                <el-menu-item index="/PersonalCenter" v-if="!isYS" >个人中心</el-menu-item>
                                <el-menu-item index="/personalFiles" v-else>个人中心</el-menu-item>
                                <el-menu-item @click.native="editPassword">修改密码</el-menu-item>
                            </el-submenu>
                            <el-submenu index="6">
                                <template slot="title">手机版</template>
                                <el-menu-item index class="erweimaSJ">
                                    <div>
                                        <img
                                            src="../../assets/img/ma.png"
                                            alt
                                            style="width:100px;height:100px"
                                        />
                                    </div>
                                </el-menu-item>
                            </el-submenu>
                            <el-submenu index="7" style="width:100px">
                                <template slot="title">网站导航</template>
                                <el-menu-item index @click="goIndex">首页</el-menu-item>
                                <el-menu-item index @click="zizhen()">中医自测</el-menu-item>
                                <el-menu-item index="/ForumIndex">中医讲堂</el-menu-item>
                                <el-menu-item index="/ancPre">古方大全</el-menu-item>
                                <el-menu-item index="/HerbalMedicineIndex">中草药</el-menu-item>
                                <el-menu-item index="/LibraryIndex">中医文库</el-menu-item>
                                <el-menu-item index="/JingLuoIndex">经络穴位</el-menu-item>
                                <el-menu-item index="/ShopIndex">药城</el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog
            custom-class="small-dialog-box"
            title="修改密码"
            :close-on-click-modal="false"
            v-if="dialogData.dialogFormVisible"
            :visible.sync="dialogData.dialogFormVisible"
            center
            width="400px"
        >
            <el-form :model="dialogData.form" label-width="80px" :rules="rules" ref="form">
                <el-form-item label="旧密码" prop="oldpassword">
                    <el-input
                        size="small"
                        type="password"
                        v-model.trim="dialogData.form.oldpassword"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newpassword">
                    <el-input
                        size="small"
                        type="password"
                        v-model.trim="dialogData.form.newpassword"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="sureNew">
                    <el-input
                        size="small"
                        type="password"
                        v-model.trim="dialogData.form.sureNew"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogData.dialogFormVisible = false">取 消</el-button>
                <el-button size="small" type="danger" @click="submitDialog('form')" class="red">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "header1",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.dialogData.form.sureNew !== "") {
                    this.$refs.form.validateField("sureNew");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.dialogData.form.newpassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            rules: {
                oldpassword: [
                    { required: true, message: "请输入旧密码", trigger: "blur" }
                ],
                newpassword: [
                    { validator: validatePass, trigger: "blur" },
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                sureNew: [
                    { validator: validatePass2, trigger: "blur" },
                    {
                        required: true,
                        message: "请输入确定密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ]
            },
            // activeIndex: "1",
            login: true, //是否显示登陆,注册按钮
            name: "", //真实姓名
            isYS: false,
            dialogData: {
                dialogFormVisible: false,
                form: {
                    id: "",
                    oldpassword: "",
                    newpassword: "",
                    sureNew: ""
                }
            },
            ysWords: "医师注册",
            displayNone: false
        };
    },
    computed: {
        onRoutes() {
            // this.$route.path
            // debugger
            if (this.$route.path.replace("/", "") == "login") {
                return "/login";
            } else if (this.$route.path.replace("/", "") == "register") {
                return "/register";
            } else if (this.$route.path.replace("/", "") == "ysRegister") {
                return "/ysRegister";
            } else {
                return this.$route.path.replace("/", "");
            }
        }
    },
    methods: {
        //修改密码
        editPassword() {
            this.dialogData.dialogFormVisible = true;
        },
        goIndex() {
            this.$router.push({
                path: "/index"
            });
            // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },

        handleSelect(index) {
            this.activeIndex = index;
        },
        //退出登陆
        signOut() {
            let that = this;
            if (sessionStorage.getItem("userInfo")) {
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            }
            let url = "/user/saveLastOnlineTime";
            let params = {
                // id: that.userInfo.id
            };
            that.$http
                .post(url, params)
                .then(res => {
                    if (res.data.code == 200) {
                        sessionStorage.clear();
                        that.login = true;
                        that.$router.replace({
                            path: "/login"
                        });
                        // 刷新兄弟组件
                        let NewPage =
                            "_empty" + "?time=" + new Date().getTime() / 500;
                        this.$router.push(NewPage);
                        this.$router.go(-1);
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message("网络错误！");
                });
        }
    },
    created() {
        let that = this;
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            if (this.userInfo.id) {
                this.login = false;
            } else {
                this.login = true;
            }
            if (this.userInfo.userType == 2) {
                this.displayNone = true;
            } else {
                this.displayNone = false;
            }
            if (JSON.parse(sessionStorage.getItem("YS"))) {
                this.isYS = JSON.parse(sessionStorage.getItem("YS"));
            } else {
                that.ysWords = "医师申请";
            }
        } else {
            that.ysWords = "医师注册";
        }

        that.routers = this.$router.options.routes[0].children;
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.displayNoneClass {
    display: none;
}
.HeadPortrait {
    float: left;
    width: 30px;
    height: 30px;
    /* border-radius: 50%; */
    /* overflow: hidden; */
    margin-right: 5px;
    /* margin-top: 5px; */
}
.HeadPortrait img {
    max-width: 100%;
    min-height: 100%;

    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.head-title {
    font-size: 12px;
    line-height: 40px;
    letter-spacing: 1.9px;
    color: #fcc2b6;
}
.top-head {
    width: 100%;
    height: 40px;
    background-color: #f64420;
}
.top-head .el-col,
.top-head .el-row {
    height: 100%;
}
.el-menu-black > .el-menu-item {
    line-height: 40px;
    height: 40px;
    font-size: 12px;
}
/* .el-menu.el-menu--horizontal {
    line-height: 40px;
    height: 40px;
    font-size: 12px;
}
.el-menu--horizontal > .el-menu-item{
    height: 40px !important;
    line-height: 40px !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
} */
.el-menu-black {
    /* line-height: 40px;
    height: 40px; */
    float: right;
}
.el-menu-white {
    width: 650px;
    border: none;
    float: right;
}
.bottom-head {
    padding: 20px 0px;
}
.head-logo {
    max-height: 60px;
}
.head-logo img {
    display: block;
    height: 60px;
}
/* .el-menu--horizontal .el-menu .el-menu-item, */
.el-menu--horizontal .el-menu .el-menu-item:hover {
    /* color: #fff !important; */
    background-color: #f96142 !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active {
    color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/topHead.vue